import PropTypes from 'prop-types';
import React from 'react';
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions
} from '@mui/material';
import { Box } from '@mui/system';
import PrimaryButton from '../../../Common/Button/primary-button.js';
import CrossIcon from '../../../../Assets/Images/close-circle.svg';
import DatePickerInput from './date-picker-input.js';

const DatePickerDialog = ({
	open,
	onClose,
	startDate,
	endDate,
	handleStartDateChange,
	handleEndDateChange,
	handleApply
}) => (
	<Dialog
		open={open}
		slotProps={{ paper: { style: { width: '304px', borderRadius: '8px' } } }}
	>
		<DialogTitle
			display={'flex'}
			justifyContent={'space-between'}
			alignContent={'center'}
		>
			<div>Please select date</div>
			<Box
				component={'img'}
				src={CrossIcon}
				alt='CrossIcon'
				onClick={() => onClose(false)}
				style={{ cursor: 'pointer' }}
			/>
		</DialogTitle>
		<DialogContent>
			<div style={{ display: 'flex', flexDirection: 'column' }}>
				<div
					style={{
						display: 'flex',
						gap: '10px',
						alignItems: 'center',
						margin: '10px 0'
					}}
				>
					<DatePickerInput
						value={startDate}
						onChange={handleStartDateChange}
						placeholder='Start Date'
						width='215px'
					/>
					<span>To</span>
				</div>
				<DatePickerInput
					value={endDate}
					onChange={handleEndDateChange}
					placeholder='End Date'
					width='215px'
				/>
			</div>
		</DialogContent>
		<DialogActions
			sx={{
				display: 'flex',
				justifyContent: 'space-between',
				padding: '0 25px 20px'
			}}
		>
			<PrimaryButton
				value='Cancel'
				onClick={onClose}
				color='primary'
				width='114px'
				height='40px'
				backgroundColor='#d9d9d9'
				padding='12px 16px'
				borderRadius='8px'
			/>
			<PrimaryButton
				value='Apply'
				onClick={handleApply}
				color='primary'
				width='114px'
				height='40px'
				backgroundColor='#B7D423'
				padding='12px 16px'
				borderRadius='8px'
			/>
		</DialogActions>
	</Dialog>
);

export default DatePickerDialog;

DatePickerDialog.propTypes = {
	open: PropTypes.any,
	onClose: PropTypes.any,
	startDate: PropTypes.any,
	endDate: PropTypes.any,
	handleStartDateChange: PropTypes.any,
	handleEndDateChange: PropTypes.any,
	handleApply: PropTypes.any
};
